import React from 'react';
import styles from '@/styles/components/TimestampMark.module.css';
import _ from 'lodash';

export interface TimestampMarkData {
  createdAt: Date;
  modifiedAt: Date;
}

function format(date: Date): string {
  return (
    _.padStart((date.getMonth() + 1).toString(), 2, '0') +
    '/' +
    date.getDate().toString() +
    '/' +
    date.getFullYear().toString()
  );
}

export const TimestampMark: React.FC<TimestampMarkData> = props => {
  return (
    <div className={styles.timestampMarkContainer}>
      <span className={styles.timestampMarkElement}>
        Created on: {format(props.createdAt)}
      </span>
      <div className={styles.timestampMarkElementSeparator}>|</div>
      <span className={styles.timestampMarkElement}>
        Last Modified on: {format(props.modifiedAt)}
      </span>
    </div>
  );
};
